import { type FC } from 'react';
import styles from './PanelSection.module.css';
import type { SimplePanelSectionProps } from './shared';

const SimplePanelSection: FC<Omit<SimplePanelSectionProps, 'variant'>> = ({
  heading,
  fieldGroups,
}) => (
  <div className={styles.simpleWrapper}>
    {heading && <div className={styles.heading}>{heading}</div>}
    <div className={styles.fieldGroups}>
      {fieldGroups.map((fieldGroup, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={`field-group-${index}`} className={styles.fieldGroup}>
          {fieldGroup}
        </div>
      ))}
    </div>
  </div>
);

export default SimplePanelSection;
